const data = {
  counterText: '선착순 예약 진행 중',
  loading: '로드 중',
  next: '다음',
  previous: '이전 단계',
  smCounterText: '선착순 모집',
};

export default data;
